<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">{{ title }} {{ produkInput.setDefault }}</h2>
    <div class="d-block text-subtitle-2 pb-3">
      Pastikan produk Anda sudah sesuai dengan syarat dan ketentuan HWI Ecommerce. 
      HWI Ecommerce menghimbau seller untuk menjual produk dengan harga yang wajar atau produk Anda dapat diturunkan oleh HWI Ecommerce sesuai S&K yang berlaku.
    </div>

    <v-form ref="formUpdateProduct" role="form" v-if="detailProduct">
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Informasi Produk
        </v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" md="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Custom Informasi Produk
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
              <p class="mb-2 text-caption grey--text" style="color: #9e4343!important;" v-if="produkInput.setDefault == 'Ya'">Informasi produk akan ditampilkan secara default sesuai dengan informasi dari perusahaan.</p>
              <p class="mb-2 text-caption grey--text" style="color: #9e4343!important;" v-else>Seller dapat memperbarui informasi produk dan diperbolehkan mengupload gambar produk sendiri.</p>
            </v-col>

            <v-col cols="12" md="8" class="pb0-xs">
              <v-radio-group
                v-model="produkInput.setDefault"
                ref="inputDefault"
                row
                hide-details="auto"
                class="mb-2 mt-0"
                @change="setDataProductDisplay()"
              >
                <!-- :rules="(isActivate) ? rules.inputDefault : []"
                :error-messages="(errorValidation !== undefined && errorValidation['inputDefault'] !== undefined ) ? [errorValidation['inputDefault']] : []" -->
                <v-radio
                  label="Default"
                  value="Ya"
                  ref="inputDefault"
                  tabindex="2"
                ></v-radio>
                <v-radio
                  label="Custom Info"
                  value="Tidak"
                  ref="inputCustom"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Nama Produk
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold primary--text">
                {{ produkInput.nama }}
              </div>
            </v-col>
          </v-row>

          <v-row class="align-center" v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Free Ongkir
              </div>
              <!-- <p class="mb-0 text-caption grey--text">Nama min. 5 karakter, terdiri dari jenis produk, merek, dan keterangan seperti warna, bahan, atau tipe.</p> -->
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <div class="d-flex flex-row align-center">
                <v-switch
                  v-model="produkInput.isFreeDelivery"
                  dense
                  hide-details="auto"
                  class="mt-0"
                ></v-switch>
                  <!-- @change="updateDropshipperMode" -->

                <span class="font-weight-bold mt-4 ml-2" :class="(produkInput.isFreeDelivery) ? 'primary--text' : ''">{{ (produkInput.isFreeDelivery) ? 'Aktif' : 'Tidak Aktif' }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          {{ ( produkInput.setDefault == 'Ya') ? '' : 'Upload' }} Gambar Produk
          <v-chip
            small
            class="ma-2"
            color="green"
            outlined
          >
            Wajib
          </v-chip>
        </v-card-title>
        <v-card-text class="px-2">
          <v-row class="my-0 d-flex align-center justify-center flex-row">
            <v-col cols="4" sm="2" v-for="(img, idg) in imgDataProduct" :key="idg">
              <div class="product-img d-row outlined py-4 px-4" :class="img ? '' : 'emptyImg'">
                <v-img width="100%" :src="img ? img : '/assets/seller/add-image-icon.svg'"></v-img>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-card-text class="px-2" v-if="produkInput.setDefault == 'Tidak'">
          <div class="text-caption mb-2">
            Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300 px (Untuk gambar optimal gunakan minimum 700 x 700 px)
          </div>
          <div class="text-center mt-2" v-if="image_alert">
            <v-alert class=" white--text red lighten-1" dense dismissible @input="toggleAlert" v-model="image_alert">Produk harus disertai gambar</v-alert>
          </div>

          <v-row class="my-5 d-flex align-center justify-center flex-row" v-if="imgPreview.length > 0">
            <v-col cols="4" sm="2" v-for="(img, idg) in imgUbahProduct" :key="idg">
              <div class="product-img d-row outlined py-4 px-4" :class="img ? '' : 'emptyImg'">
                <v-img width="100%" :src="img ? img : '/assets/seller/add-image-icon.svg'"></v-img>
                <v-btn
                  v-if="img"
                  class="mx-0 close-btn"
                  fab
                  dark
                  x-small
                  color="red"
                  @click="removeImage(idg)"
                >
                  <v-icon dark>
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <div v-show="false">
            <v-file-input
              @change="createImage($event)"
              id="inputProdukImg"
              ref="fileupload"
              chips
              accept="image/*"
              multiple
              small-chips
              prepend-icon=""
              truncate-length="50"
            ></v-file-input>
          </div>

          <div class="v-row d-flex flex-column align-center">
            <v-btn
              color="success"
              elevation="2"
              dark
              min-width="140"
              class="my-3"
              @click="openUpload"
            >
              <strong class="text-capitalize text-subtitle-2 font-weight-bold"><v-icon color="white darken-1 mr-2">mdi-plus</v-icon> Pilih Gambar Produk</strong>
            </v-btn>

            <!-- <v-btn
              color="warning"
              elevation="2"
              dark
              min-width="140"
              class="my-3"
              v-else
            >
              <strong class="text-capitalize text-subtitle-2 font-weight-bold"><v-icon color="white darken-1 mr-2">mdi-upload</v-icon> Upload Produk</strong>
            </v-btn> -->
            <div class="text-caption font-weight-bold">
              Unggah hingga 5 gambar sekaligus disini.
            </div>
          </div>
        </v-card-text>
      </v-card>
      
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Detail Produk
        </v-card-title>
        <v-card-text class="px-2 pb-0">

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Deskripsi Produk
              </div>
              <p class="mb-0 text-caption grey--text">Pastikan deskripsi produk memuat spesifikasi, ukuran, bahan, masa berlaku, dan lainnya. Semakin detail, semakin berguna bagi pembeli.</p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs" v-show="produkInput.setDefault == 'Ya'">
              <div class="d-block border rounded pa-4" style="min-height: 300px;" v-html="produkInput.deskripsi"></div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs" v-show="produkInput.setDefault == 'Tidak'">
              <Vueditor ref="editor"></Vueditor>
            </v-col>
          </v-row>

          <v-row>
            <v-col  cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Link Video Produk (Youtube)
              </div>
              <p class="mb-0 text-caption grey--text">Masukkan link video youtube produk terkait untuk ditampilkan pada informasi produk ecommerce.</p>
            </v-col>
            <v-col  cols="12" sm="8" class="pb0-xs" v-if="!produkInput.youtube || produkInput.youtube.length == 0">
              <v-text-field
                v-model="produkInput.youtube"
                outlined
                x-small
                dense
                hide-details="auto"
                prepend-inner-icon="mdi-youtube"
              ></v-text-field>
            </v-col>
            <v-col  cols="12" sm="8" class="pb0-xs" v-else>
              <v-text-field
                v-model="produkInput.youtube"
                outlined
                x-small
                dense
                hide-details="auto"
                prepend-inner-icon="mdi-youtube"
                :rules="(produkInput.youtube !== '') ? linkYtRules : []"
                :error-messages="responseError.youtube"
                :disabled="(produkInput.productId == '' || produkInput.setDefault == 'Ya') ? true : false"
              ></v-text-field>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Harga Produk
        </v-card-title>
        <v-card-text class="px-2">

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Harga Satuan
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
            </v-col>

            <v-col cols="12" sm="4" class="pb0-xs">
              <label class="mb-2 font-weight-bold d-block">Harga Jual Minimal (HK1) <span class="primary--text">{{ detailProduct.product_dropshipper_price_min | toRupiah }}</span></label>
              <template v-if="allowToShow">
                <v-currency-field
                  v-model="produkInput.hargaSatuan"
                  :rules="priceRules"
                  outlined
                  small
                  dense
                  placeholder="Masukkan harga"
                  prefix="Rp"
                  hide-details="auto"
                  :error-messages="responseError.price"
                  @focus="() => responseError.price=''"
                  persistent-hint
                  hint="Harga jual produk ke konsumen"
                ></v-currency-field>
              </template>

              <!-- <template>
                <h3>{{ produkInput.hargaSatuan | toRupiah }}</h3>
              </template> -->
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>

      <!--  v-if="allowToShow" -->
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Pengelolaan Stok
        </v-card-title>
        <v-card-text class="px-2">

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Stok Produk
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.stok"
                :rules="stockRules"
                outlined
                small
                dense
                placeholder="Masukkan jumlah stok"
                hide-details="auto"
                :error-messages="responseError.quantity"
                @focus="() => responseError.quantity=''"
              ></v-currency-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5" v-if="false">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Berat &amp; Pengiriman Produk
        </v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Berat Produk
                <v-chip
                  x-small
                  class="ma-2 py-2 font-weight-bold"
                  color="green"
                  outlined
                >
                  Wajib
                </v-chip>
              </div>
              <p class="mb-0 text-caption grey--text">Masukkan berat dengan menimbang produk setelah dikemas.</p>
            </v-col>

            <v-col cols="12" sm="3" class="pb0-xs">
              <v-autocomplete
                v-model="produkInput.unitberat"
                :items="weightUnits"
                :rules="weightUnitRules"
                item-text="text"
                item-value="multiple"
                placeholder="Satuan"
                hide-details="auto"
                outlined
                dense
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" class="pb0-xs">
              <v-currency-field
                v-model="produkInput.berat"
                :rules="weightRules"
                outlined
                small
                dense
                hide-details="auto"
                placeholder="Masukkan berat"
                :decimalLength="2"
                :error-messages="responseError.weight"
                @focus="() => responseError.weight=''"
              ></v-currency-field>
            </v-col>
          </v-row>

          <v-row v-if="false">
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Asuransi Pengiriman
              </div>
              <p class="mb-0 text-caption grey--text">Gunakan asuransi pengiriman untuk menjamin kerugian, kerusakan, &amp; kehilangan selama pengiriman produk.</p>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-radio-group
                v-model="produkInput.asuransi"
                hide-details="auto"
                row
                class="my-0"
              >
                <v-radio
                  label="Opsional"
                  value="0"
                ></v-radio>
                <v-radio
                  label="Ya"
                  value="1"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>

    <v-layout v-resize="onResize" column>
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-text>
          <v-row>
            <v-col cols="12" class="text-right py-0 px-0">
              <v-btn
                color="error"
                elevation="2"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                class="mr-2"
                v-if="!isMobile"
                @click="cancelForm()"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>

              <v-btn
                color="success"
                elevation="2"
                dark
                min-width="140"
                :loading="loadingProcess"
                @click="update"
                :class="(isMobile) ? 'v-btn--block mb-3' : ''"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Simpan</strong>
              </v-btn>

              <v-btn
                color="error"
                elevation="2"
                outlined
                dark
                min-width="140"
                :loading="loadingProcess"
                :class="(isMobile) ? 'v-btn--block mb-3' : 'mr-2'"
                v-if="isMobile"
                @click="cancelForm()"
              >
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
const defaultInput = () => ({
  nama: '',
  slug: '',
  productId: '',
  store_productId: '',
  kondisi: '1',
  deskripsi: '',
  minOrder: 0,
  hargaSatuan: '',
  status: 'active',
  stok: 0,
  berat: 0,
  unitberat: 0,
  unit: '',
  image: [],
  isFreeDelivery: false,
  youtube: '',
  setDefault: 'Ya'
})

function validateYoutube(link) {
  if (link != '') {
    var re = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/watch\?v=([^&]+)/m;
    return re.test(link);
  } else {
    return true
  }
}

export default {
  data() {
    return {
      title: '',
      image_alert: false,
      loading: false,
      allowToShow: true,
      nameRules: [
        v => !!v || 'Nama produk tidak boleh kosong',
        v => v.length >= 5 || 'Nama produk minimal 5 karakter',
      ],
      unitRules: [
        v => !!v || 'Satuan produk tidak boleh kosong',
      ],
      categoryRules: [
        v => !!v || 'Kategori produk tidak boleh kosong',
      ],
      priceRules: [
        v => !!v || 'Harga produk tidak boleh kosong',
      ],
      priceB2bRules: [
        v => !!v || 'Harga produk tidak boleh kosong',
        () => parseInt(this.produkInput.hargaB2b) < parseInt(this.produkInput.hargaSatuan) || 'Harga B2B harus lebih rendah daripada harga satuan'
      ],
      stockRules: [
        v => !!v || 'Stok produk tidak boleh kosong',
      ],
      weightUnitRules: [
        v => !!v > 0 || 'Tidak boleh kosong',
      ],
      weightRules: [
        v => parseInt(v) > 0 || 'Tidak boleh kosong',
      ],
      linkYtRules: [
        v => !!validateYoutube(v) || 'Format link youtube produk tidak sesuai',
      ],
      imgPreview: [],
      produkInput: defaultInput(),
      units: ['unit', 'pcs', 'lembar', 'kotak'],
      weightUnits: [
        {text: 'Gram (g)', multiple: 1}, 
        // {text: 'Kilogram (Kg)', multiple: 1000}
      ],
      isMobile: false,
      loadingProcess: false,
      displayProduct: {
        selected: {},
        lists: [],
        pagination: {}
      },
    }
  },

  computed: {
    ...mapState('productSeller', ['responseError', 'detailProduct']),
    ...mapState('storeSeller', ['detailStore']),
    ...mapState('authSeller', ['isAuth', 'sellerData']),

    imgDataProduct() {
      let img = []
      
      if (Object.keys(this.detailProduct).length > 0) {
        for(var i = 0; i < Object.keys(this.detailProduct.store_product_product_image_detail).length; i++ ) {
          img[i] = this.detailProduct.store_product_product_image_detail.length > 0 ? this.detailProduct.store_product_product_image_detail[i] : []
        }
      }

      return img
    },

    imgUbahProduct() {
      let img = []
      for(var i = 0; i < 5; i++ ) {
        img[i] = this.imgPreview[i] ? this.imgPreview[i].img : undefined
      }
      return img
    },
  },

  methods: {
    ...mapActions('productSeller', ['updateStoreProduct', 'uploadImage', 'getStoreProductDetail']),
    ...mapMutations('productSeller', ['clearProduct']),
    ...mapMutations(['makeAlert']),
    ...mapActions('storeSeller', ['getStoreDetail']),
    // ...mapState('authSeller', ['sellerData']),

    async getDisplayProduct(id) {
			await this.$http
				.get(`/product/get-product`, {
					// ...this.apiHeaders
				})
				.then((res) => {
					const data = res.data.data
					this.displayProduct.lists = data.results
					this.displayProduct.pagination = data.pagination
          this.displayProduct.selected = this.displayProduct.lists.find(item => { return item.product_id == id })
				})
				.catch((error) => {
					// err = error
					console.log(error.response.data.message)
				})
		},

    setDataProductDisplay() {
      if (this.produkInput.setDefault == 'Ya') {
        console.log(this.displayProduct)
        this.produkInput.nama = this.displayProduct.selected.product_name
        this.produkInput.productId = this.router.params.id
        this.produkInput.store_productId = this.displayProduct.selected.product_id
        this.produkInput.deskripsi = this.displayProduct.selected.product_description
        this.produkInput.hargaSatuan = 0
        this.produkInput.stok = 0
        this.produkInput.berat = this.displayProduct.selected.product_weight
        this.produkInput.image = []
        this.produkInput.youtube = this.displayProduct.selected.product_video
          // this.produkInput.setDefault = 'Ya'

        this.produkInput.image.push(this.displayProduct.selected.product_image)
        // if (Object.keys(this.displayProduct).length > 0) {
        //   for(let i = 0; i < Object.keys(this.displayProduct.product_image_detail).length; i++ ) {
        //     this.imgPreview.push(this.displayProduct.product_image_detail[i])
        //   }
        // }
      } else {
        
        this.produkInput.nama = this.detailProduct.product_name
        this.produkInput.productId = this.detailProduct.store_product_id
        this.produkInput.store_productId = this.detailProduct.store_product_product_id
        this.produkInput.deskripsi = this.detailProduct.store_product_product_description
        this.produkInput.hargaSatuan = this.detailProduct.store_product_product_price
        this.produkInput.stok = this.detailProduct.store_product_stock_balance
        this.produkInput.berat = this.detailProduct.product_weight
        this.produkInput.image = []
        this.produkInput.youtube = this.detailProduct.store_product_product_video

        this.$refs.editor.setContent('')

        setTimeout(() => {
          this.$refs.editor.setContent(this.detailProduct.store_product_product_description)
        }, 500);
        // this.produkInput.setDefault = this.detailProduct.store_product_default_product

        this.produkInput.image.push(this.detailProduct.store_product_product_image)
        // if (Object.keys(this.detailProduct).length > 0) {
        //   for(let i = 0; i < Object.keys(this.detailProduct.store_product_product_image_detail).length; i++ ) {
        //     this.imgPreview.push(this.detailProduct.store_product_product_image_detail[i])
        //   }
        // }
      }
    },

    setAllowToShow() {
      if (this.sellerData.store_is_dropship == 'Ya') {
        if (this.sellerData.store_is_seller == 'Ya') this.allowToShow = true
        // else this.allowToShow = false
        else this.allowToShow = true
      } else if (this.sellerData.store_is_dropshipper == 'Ya') {
        if (this.sellerData.store_is_seller == 'Ya') this.allowToShow = true
        else this.allowToShow = true
      }
    },

    removeImage(index) {
      this.imgPreview.splice(index, 1)
    },

    removeImageOld(index, url) {
      const lastSegment = url.split("/").pop();
      this.removeProductImage({
        filename: lastSegment
      }).then(() => {
        this.detailProduct.product_image.splice(index, 1)
      })
    },

    async openUpload() {
      const input = await document.getElementById('inputProdukImg')
      input.click()
    },

    createImage(event) {
      var dimensions = [];
      event.forEach((el) => {
        dimensions.push(new Promise(function (resolve) {
          
          var reader = new FileReader();
          reader.onload = (e) => {
            resolve({
              img: e.target.result,
              file: el
            })
          };
          reader.readAsDataURL(el);
        }));
      });

      Promise.all(dimensions).then((res) => {
        if (res.length > 5)
          this.makeAlert({ code: 'error_response', type: 'error', message: 'Gambar maksimal 5', show: true })

        res.splice(5 - this.imgPreview.length, res.length - 1)
        this.imgPreview = [...this.imgPreview, ...res]

        if (this.imgPreview.length > 0)
          this.image_alert = false
      }).catch(function(err) {
        console.log(err)
      })
    },

    async update() {
      this.loadingProcess = await true
      // if (this.imgPreview.length > 0) {
          this.image_alert = false
      
        let imgList = this.imgPreview.map(x => x.file)

        let params = new FormData()
        params.append('store_product_id', this.produkInput.productId)
        params.append('store_product_default_product', this.produkInput.setDefault)
        params.append('store_product_product_id', this.produkInput.store_productId)
        params.append('store_product_stock_balance', this.produkInput.stok)
        params.append('store_product_product_video', (this.produkInput.youtube) ? this.produkInput.youtube : '')
        // if (this.sellerData.store_is_seller == 'Ya') params.append('store_product_stock_balance', this.produkInput.stok)
        // else params.append('store_product_stock_balance', 0)

        // if (this.produkInput.isFreeDelivery) params.append('store_product_is_free_delivery', 'Ya')
        // else params.append('store_product_is_free_delivery', 'Tidak')
        
        if (this.allowToShow) {
          params.append('store_product_product_price', this.produkInput.hargaSatuan)
          
          if (this.produkInput.setDefault == 'Tidak') {
            params.append('store_product_product_description', (this.$refs.editor.getContent()) ? this.$refs.editor.getContent() : '')
            if (imgList[0]) params.append('store_product_product_image[0]', imgList[0])
            if (imgList[1]) params.append('store_product_product_image[1]', imgList[1])
            if (imgList[2]) params.append('store_product_product_image[2]', imgList[2])
            if (imgList[3]) params.append('store_product_product_image[3]', imgList[3])
            if (imgList[4]) params.append('store_product_product_image[4]', imgList[4])
          } else {
            params.append('store_product_product_description', this.detailProduct.store_product_product_description)
          }
          
        } else {
          params.append('store_product_product_description', this.detailProduct.store_product_product_description)
          // params.append('store_product_product_image[0]', (imgList[0]) ? imgList[0] : '')
          // params.append('store_product_product_image[1]', (imgList[1]) ? imgList[1] : '')
          // params.append('store_product_product_image[2]', (imgList[2]) ? imgList[2] : '')
          // params.append('store_product_product_image[3]', (imgList[3]) ? imgList[3] : '')
          // params.append('store_product_product_image[4]', (imgList[4]) ? imgList[4] : '')
        }

        await this.updateStoreProduct(params).then( () => {
          this.$router.push({ name: 'seller-produk' })
          this.$refs.formUpdateProduct.resetValidation()
          this.$refs.fileupload.clearableCallback()
          this.imgPreview = []
          this.produkInput = defaultInput()
          this.loadingProcess = false

        })
        .catch(() => {
          this.loadingProcess = false
        })
      // } else {
      //   this.image_alert = true
      //   this.loadingProcess = false
      // }
    },

    cancelForm() {
      this.$router.push('/seller/produk-saya')
    },

    toggleAlert(val) {
      this.image_alert = val
    },

    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  created() {
    this.$store.dispatch('setPageTitle', `Ubah Produk Saya`);
    this.loading = true
    this.getStoreDetail()
    let router = this.$route
    this.title = "Ubah Produk"
    this.getStoreProductDetail({
      store_product_id: router.params.id,
    }).then(() => {
      // this.produkInput.nama = this.detailProduct.product_name
      // this.produkInput.slug = this.detailProduct.product_slug_name
      // this.produkInput.kategori = this.detailProduct.product_category_id
      // this.produkInput.deskripsi = this.detailProduct.product_description
      // this.produkInput.hargaSatuan = this.detailProduct.product_price
      // this.produkInput.hargaB2b = this.detailProduct.b2b_product_price_original
      // this.produkInput.status = this.detailProduct.product_is_active
      // this.produkInput.stok = this.detailProduct.store_stock_quantity
      // this.produkInput.berat = this.detailProduct.product_weight
      // this.produkInput.unitberat = this.detailProduct.product_weight >= 1000 ? 1000 : 1
      // this.produkInput.unit = this.detailProduct.product_unit
      this.produkInput = {
        nama: this.detailProduct.product_name,
        productId: this.detailProduct.store_product_id,
        store_productId: this.detailProduct.store_product_product_id,
        kondisi: '1',
        deskripsi: this.detailProduct.store_product_product_description,
        minOrder: 0,
        hargaSatuan: this.detailProduct.store_product_product_price,
        status: 'active',
        stok: this.detailProduct.store_product_stock_balance,
        berat: this.detailProduct.product_weight,
        unitberat: 1,
        unit: 1,
        image: [],
        youtube: this.detailProduct.store_product_product_video,
        setDefault: this.detailProduct.store_product_default_product
      }

      this.getDisplayProduct(this.detailProduct.store_product_product_id)

      this.produkInput.image.push(this.detailProduct.store_product_product_image)
      // if (Object.keys(this.detailProduct).length > 0 && this.allowToShow) this.$refs.editor.setContent(this.detailProduct.store_product_product_description)
      if (Object.keys(this.detailProduct).length > 0 && this.detailProduct.store_product_default_product == 'Tidak') this.$refs.editor.setContent(this.detailProduct.store_product_product_description)
      
      // if (Object.keys(this.detailProduct).length > 0) {
      //   for(var i = 0; i < Object.keys(this.detailProduct.store_product_product_image_detail).length; i++ ) {
      //     this.imgPreview.push(this.detailProduct.store_product_product_image_detail[i])
      //   }
      // }
      
      setTimeout(() => {
        this.loading = false
      }, 600);
      if (this.detailProduct.store_product_product_image_detail.length > 0) this.produkInput.image.concat(this.detailProduct.store_product_product_image_detail)
    }).catch((err) => {
      console.log(err)
      setTimeout(() => {
        this.loading = false
        // this.$router.push({name: 'seller-produk'})
      }, 3000)
    })
  },
}
</script>

<style lang="scss" scoped>
  .product-img {
    border: 2px solid green;
    border-radius: 4px;

    &.emptyImg {
      border: 2px solid #ddd;
    }
  }
  .product-img {
    position: relative;
    .close-btn {
      position: absolute;
      top: -15px;
      right: -15px;
      height: 28px;
      width: 28px;
    }
  }
</style>